import { createFileRoute } from '@tanstack/react-router'
import { useRouteDigitalProductId } from '@/shared/hooks/useRouteDigitalProductId'

import { DigitalProductAnalytics } from '@/features/public-pages/Analytics'

export const Route = createFileRoute('/_event/p/analytics')({
  staticData: {
    isPublic: true
  },
  component: DigitalProductAnalyticsPage
})

function DigitalProductAnalyticsPage() {
  const digitalProductId = useRouteDigitalProductId()

  return (
    <DigitalProductAnalytics
      digitalProductId={digitalProductId}
      id={digitalProductId}
    />
  )
}
